import { Glyph } from "./glyphs";

export function isStandaloneRhythmSymbol(symbol) {
  return /^(dotted_)?(whole|half|quarter|eighth|sixteenth|thirty_second)_(note|rest)$/.test(
    symbol || "",
  );
}

// Use only off a staff: half rests sit on the line, whole rests hang below it.
// The shared staff glyph already has the right vertical position at y=0.
export default function StandaloneRhythmGlyph({
  symbol,
  width = 70,
  height,
  label = symbol.replaceAll("_", " "),
}) {
  const base = symbol.replace(/^dotted_/, "");
  const viewBox =
    base === "half_rest" || base === "whole_rest"
      ? "-15.4375 -26 44 52"
      : base === "thirty_second_note"
        ? "-9 -70 44 80"
        : base === "thirty_second_rest"
          ? "-9 -30 44 65"
          : base.endsWith("_rest")
            ? "-9 -26 44 52"
            : "-9 -40 44 52";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height ?? (base === "thirty_second_note" ? 100 : 70)}
      viewBox={viewBox}
      role="img"
      aria-label={label}
      style={{ flexShrink: 0, verticalAlign: "middle" }}
      data-standalone-rhythm={symbol}
    >
      {(base === "half_rest" || base === "whole_rest") && (
        <line x1="-8" x2="21.125" y1="0" y2="0" stroke="#000" strokeWidth="1" />
      )}
      <Glyph symbol={symbol} stemUp />
    </svg>
  );
}
